export default "/images/fc5d73ea986cecb82441635b59496451.png";